jQuery(function($) { $('#instagram').load('https://sf.appsbyba.com/instagram/feed/house-of-harvey-co.myshopify.com') });

jQuery(window).scroll(function() {
	jQuery("#shopify-section-header").addClass("shrink");

    var scroll = jQuery(window).scrollTop();
    var scrollBottom = jQuery(document).height() - jQuery(window).height() - jQuery(window).scrollTop();
    //console.log($(document).height() - $(window).height() - $("#enquiry").height())

    if (scroll <= 100) {
        jQuery("#shopify-section-header").removeClass("shrink");
    }
}).scroll();



jQuery(document).ready(function ($) {

	// ------------------------------------------------------------------
    // -------------------- GET HEIGHT OF PAGE --------------------------
    // ------------------------------------------------------------------
    // create function to give height of window

    getWidthAndHeight();

    jQuery(window).resize(function() {
      getWidthAndHeight();
    });

    function getWidthAndHeight (){
      var winHeight = $(window).height();
      var winWidth = $(window).width();

      // home slider
      var navHeight = $('#shopify-section-header').height();
      
      //$('.template-index .main-content').css({'margin-top': navHeight-5 });
      $('.main-content').css({'margin-top': navHeight-5 });

    };
});